(function ($) {
  'use strict';
  $(document).ready(function () {

    function createCookie(name, value, days) {
      var expires;

      if (days) {
        var date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();

      }
      else {
        expires = "";
      }
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    function CookiePolicy() {
      var cookie = readCookie("Epilepsy_Cookie_Policy");

      if (cookie == null || cookie != "Accept") {

        $(".cookie-disclaimer").slideDown(600, function () {
          $(".cookie-disclaimer").addClass('open').removeClass('close');
        });
      }
    }

    setTimeout(CookiePolicy, 1000);


    // Cookies Close
    $(".cookie-disclaimer >a").click(function (e) {
      e.preventDefault();
      $(".cookie-disclaimer").slideUp(600, function () {
        $(".cookie-disclaimer").addClass('close').removeClass('open');
      });
    });

    // Cookie Accept
    $(".cookie-disclaimer .btn").click(function (e) {
      e.preventDefault();
      var cookie = readCookie("Epilepsy_Cookie_Policy");

      if (cookie == null)
        createCookie("Epilepsy_Cookie_Policy", "Accept", 1);

      $(".cookie-disclaimer").slideUp(600, function () {
        $(".cookie-disclaimer").addClass('close').removeClass('open');
      });
    });

  });

})(jQuery);